var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"id":"qrcode","width":_vm.width,"height":_vm.width}})}
var staticRenderFns = []

export { render, staticRenderFns }